// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { OOI_EXPERIMENTS } from '@app/experiments';
import { uouTagClickedEvent } from '../../common/bi-events/uou-events/uou-tag-clicked-event';
/** @deprecated Remove when merging {@link OOI_EXPERIMENTS.USE_NEW_TAG_CLOUD_SETTINGS_URL} */
export const eventMap = {
  ...uouTagClickedEvent,
};
